import { Button, Input, Text } from "@mantine/core";
import { IconAt } from "@tabler/icons-react";
import { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Select } from "src/components/shared/MantineCombobox";
import { useIsOnline, usePostApi } from "src/hooks";
import { Notification } from "src/utils/Notification";

import { BackButton } from "../Forms.styled";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const isOnline = useIsOnline();

  const { register, handleSubmit } = useForm<{ email: string }>();
  const [userList, setUserList] = useState<
    Array<{ value: string; label: string }>
  >([]);
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const { post, isLoading } = usePostApi();

  const handleBack = () => {
    navigate("/login");
  };

  useEffect(() => {
    if (!isOnline) {
      navigate("/login");
      Notification(
        "Offline Redirect",
        "You appeared to be offline. Unfortunately previous view works only online",
        "yellow",
      );
    }
  }, [isOnline, navigate]);

  const handleReset = async (data: { email: string }) => {
    if (userList.length > 0 && !selectedUser) {
      return;
    }

    let params = {};

    if (selectedUser) params = { multi: true, userid: selectedUser };
    else params = { email: data.email };

    await post({
      request: "reset-password",
      body: { params },
      onSuccess: res => {
        if (res.multi && res.list && !selectedUser) {
          setUserList(
            res.list.map((user: any) => ({
              value: user.userid,
              label: user.full_name,
            })),
          );
          Notification(
            "Warning",
            "There is more than one user with this email",
            "blue",
          );
        } else {
          Notification(
            "Password Reset Request Sent",
            "We will send an email to your registered address with further instructions",
            "green",
          );
          handleBack();
        }
      },
    });
  };

  return (
    <>
      <form onSubmit={handleSubmit(handleReset)}>
        {userList.length > 0 ? (
          <Fragment>
            <Select
              data={userList}
              value={selectedUser}
              onChange={setSelectedUser}
              label={
                <Text c="white">
                  There are multiple users assigned to this email, select your
                  name from the list!
                </Text>
              }
            />
            <Button w="100%" mt={10} type="submit" loading={isLoading}>
              Reset password
            </Button>
          </Fragment>
        ) : (
          <Fragment>
            <Input
              leftSection={<IconAt size="1rem" />}
              placeholder="Email Address"
              {...register("email")}
            />

            <Button w="100%" mt={10} type="submit" loading={isLoading}>
              Reset password
            </Button>
          </Fragment>
        )}

        <BackButton onClick={handleBack}>Back</BackButton>
      </form>
    </>
  );
};

export default ForgotPassword;
